import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ReportReviewData {
  reviewId: string;
}

export interface ReportReviewResult {
  confirmed: boolean;
  reason: string;
  otherReason?: string;
}

@Component({
  selector: 'app-report-review',
  templateUrl: './report-review.component.html',
  styleUrls: ['./report-review.component.scss']
})
export class ReportReviewComponent {
  selectedReason: string = 'hidden';
  otherReason: string = '';

  constructor(
    public dialogRef: MatDialogRef<ReportReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportReviewData
  ) {}

  isValid(): boolean {
    if (this.selectedReason === 'other') {
      return this.otherReason.trim().length > 0;
    }
    return true;
  }

  confirm(): void {
    const result: ReportReviewResult = {
      confirmed: true,
      reason: this.selectedReason,
      otherReason: this.selectedReason === 'other' ? this.otherReason : undefined
    };
    this.dialogRef.close(result);
  }
}
